import { useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '@store';
import {
  SecurityLocks,
  PickerPosition,
  PermissionEnum,
  PermissionDenied,
} from '@ui/src';
import {
  schema,
  columns,
  columnsLabels,
  filtersSchema,
} from '../variables/locks';
import useLocksList from '../hooks/use-locks-list';

import cn from '../styles.module.css';

const IndividualCustomerSecurityLocks = () => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { activePermissions } = useAppSelector((state) => state.root);
  const { baseInformation, activeLock } = useAppSelector(
    (state) => state.individualCustomers.info.general,
  );
  const { locks, locksTakeCount, pagination } = useAppSelector(
    (state) => state.individualCustomers.info.security,
  );
  const { users } = useAppSelector((state) => state.userList.users);

  const { getList, isFetching, isLoading } = useLocksList({
    scrollRef,
    locks,
    activeLock,
  });

  let content;

  if (!activePermissions?.includes(PermissionEnum.LOCKS_LIST)) {
    content = <PermissionDenied />;
  } else {
    content = (
      <>
        <SecurityLocks
          locks={locks}
          pagination={pagination}
          takeCount={locksTakeCount}
          users={users}
          schema={schema}
          getList={getList}
          filtersSchema={filtersSchema}
          isFetching={isFetching}
          isLoading={isLoading}
          columns={columns}
          columnsLabels={columnsLabels}
          userId={baseInformation?.userId}
          tableTopClassName={cn.securityTableTop}
          expirationDatesPickerPosition={PickerPosition.RIGHT}
          withPickerTitles
        />
        <Outlet />
      </>
    );
  }

  return (
    <div className={cn.securityLocksContent} ref={scrollRef}>
      {content}
    </div>
  );
};

export default IndividualCustomerSecurityLocks;
